import React from "react"
import { graphql, Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const CalendarCardList = ({ article }) => {

  const isVideo = article.cover?.mime?.startsWith("video")
  const isGerman = typeof window !== 'undefined' && window.location.pathname.includes('/de');

  const formatDate = (dateString, locale) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(locale, options);
  };

  const englishDate = formatDate(article.eventdate, "en-US");
  const germanDate = formatDate(article.eventdate, "de-DE");

  return (
    <Link to={`/${isGerman ? 'de/' : ''}${article.slug}`} className="list-card border-b-4 border-black first:border-t-4 bg-white hover:bg-black hover:text-white transition duration-200">
      <div className="col-span-1 px-4 md:px-8">
        <div className="flex items-center">
          <div className="w-32 h-24 sm:h-20 md:w-56 md:h-32 flex-none">
            {isVideo ? (
              <div className="h-full w-full"
                dangerouslySetInnerHTML={{ __html: `<video class="allianz-player object-cover h-full w-full" playsinline autoplay loop muted><source src="${article.videocover.file.url}" type="video/mp4" /></video>` }}
              />
            ) : (
              <GatsbyImage
                image={getImage(article.cover?.file)}
                alt={article.cover?.alternativeText || "Alternative Text missing"}
                className="h-full w-full"
              />
            )}
          </div>
          <div className="px-4 md:px-24 grow">
          {article.eventdate &&
            <div className="articleMeta mb-4 grid grid-cols-1">
              <div className="flex space-x-2 justify-start">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="md:w-6 md:h-6 w-4 h-4">
                  <path d="M12.75 12.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM7.5 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM8.25 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9.75 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM10.5 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM12.75 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM14.25 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM15 17.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM16.5 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM15 12.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM16.5 13.5a.75.75 0 100-1.5.75.75 0 000 1.5z" />
                  <path fillRule="evenodd" d="M6.75 2.25A.75.75 0 017.5 3v1.5h9V3A.75.75 0 0118 3v1.5h.75a3 3 0 013 3v11.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V7.5a3 3 0 013-3H6V3a.75.75 0 01.75-.75zm13.5 9a1.5 1.5 0 00-1.5-1.5H5.25a1.5 1.5 0 00-1.5 1.5v7.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-7.5z" clipRule="evenodd" />
                </svg>
                <p className="font-semibold text-text-sm md:text-text md:-mt-0.5">
                  {isGerman && germanDate}
                  {!isGerman && englishDate}
                </p>
              </div>
            </div>
            }
            <h2 className="text-headline-listfeed tracking-headline-lg leading-none font-bold -mt-2">{article.title}</h2>
          </div>
        </div>
      </div>
    </Link>
    )
  }

export const query = graphql`
  fragment CalendarCardList on StrapiArticle {
    id
    slug
    title
    description
    eventdate
    tags {
      name
      slug
      description
    }
    videocover: cover {
      caption
      name
      url
      mime
      alternativeText
      file {
        url
      }
    }
    cover {
      caption
      name
      id
      url
      mime
      alternativeText
      file {
        url
        childImageSharp {
          gatsbyImageData(aspectRatio: 1.1)
        }
      }
    }
  }
`
export default CalendarCardList
